<template>
    <RowInfoTrip
        v-if="row.type === 'trip' && entity"
        :row="row"
        :entity="entity"
        :currency="currency"
    />
    <RowInfoIdea
        v-else-if="row.type === 'idea' && entity"
        :row="row"
        :entity="entity"
        :currency="currency"
    />
</template>

<script>
import RowInfoTrip from "js/components/blocks/RowInfoTrip";
import RowInfoIdea from "js/components/blocks/RowInfoIdea";

export default {
    name: "ScheduleRowInfo",
    components: {
        RowInfoTrip,
        RowInfoIdea,
    },
    props: {
        row: {
            type: Object,
            required: true,
        },
        entity: {
            type: Object,
            default: null,
        },
        currency: {
            type: String,
            default: "$",
        },
    },
};
</script>
